/* eslint-disable jsx-a11y/control-has-associated-label */
/* eslint-disable indent */
/* eslint-disable complexity */
/* eslint-disable react/no-unknown-property */
import React, { useState, useEffect, useContext, useCallback } from 'react';
import { useDropzone } from 'react-dropzone';
import {
  faExclamationTriangle,
  faSpinner,
  faCaretUp,
  faCaretDown,
  faPaperclip
} from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { ATCONSTANTS as ATC, allowedFileTypes } from 'appconstants';
import { DocumentHelper, OpenWarningNotification, OpenErrorNotification } from '@ctsu/react-ctsu-ui';
import _ from 'lodash';
import { FasTimes } from 'assets/icons';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { AppContext, getToken } from '@ctsu/loader';
import { FormRow, Label } from 'components/CustomComponents/FormRow';
import { getErrorMessage } from 'helpers/APIHelper';
import {
  getTemplates,
  getEmailObject,
  sendEmailObj,
  deleteAttachment,
  getProcessKey,
  clearEmailObject
} from 'actions/common';
import bindLogger from 'helpers/BindLogger';
import CopyPaste from 'components/EmailGenerator/CopyPaste';
import { showSuccessNotification, showErrorNotification, showWarningNotification } from 'helpers';

// sonar issue fix
const noReplyEmail = window.atob('Tm8tUmVwbHlfQ1RTVV9SZWd1bGF0b3J5X09mZmljZS1jdHN1QHdlc3RhdC5jb20=');

function EmailGenerator(props) {
  const {
    mode = false,
    orgType,
    keyValue,
    tagName,
    templates,
    dbId,
    errors,
    setErrors,
    emailObject,
    cancelCommunicationHanlder,
    emailId,
    reason,
    showReason,
    sendDate,
    CopyPasteFields,
    fetchEmailObject,
    fetchProcessKey,
    fetchTemplates,
    clearEmailObjectAc,
    deleteAttachmentAc,
    sendEmailObjAc
  } = props;
  const [templateOpt, setTemplateOpt] = useState([]);
  const saveRec = showReason;
  const [isUploading, setIsUploading] = useState(false);
  const [switchAc, setSwitch] = useState(false);
  const [priority, setPriority] = useState(false);
  const context = useContext(AppContext);
  const { session } = context;
  const [state, setstate] = useState(_.clone({}));
  const [view, setView] = useState(false);
  const [sendMailId, setSendMailId] = useState(null);
  const [showCopyPaste, canShowCopyPaste] = useState(false);

  useEffect(() => {
    setView(mode);
  }, [mode]);

  const resetState = () => {
    clearEmailObject();
    setErrors({});
    setstate({
      template: null,
      sendFrom: session.emailAddress,
      sendTo: null,
      emailType: null,
      processKey: null,
      cc: null,
      bcc: null,
      subject: null,
      attachments: [],
      body: null,
      priority: null
    });
  };

  useEffect(() => {
    if (orgType && keyValue) {
      bindLogger(fetchTemplates, context)(orgType, keyValue);
      if (!emailId) {
        setstate(prevState => {
          return {
            ...prevState,
            template: null,
            sendFrom: session.emailAddress,
            sendTo: null,
            processKey: null,
            cc: null,
            bcc: null,
            subject: null,
            attachments: [],
            body: null,
            priority: null
          }
        });
      }
    }
  }, [orgType, keyValue, emailId, fetchTemplates, session.emailAddress, context]);

  useEffect(() => {
    if (emailObject == null) {
      setSwitch(false);
    }

    if (emailObject && state.template) {
      const {
        sendTo, subject, body, attachments, processKey, priority
      } = emailObject;
      setstate(prevState => {
        return {
          ...prevState,
          sendTo,
          subject,
          processKey,
          body,
          attachments,
          bcc: emailObject.bcc || '',
          cc: emailObject.cc || '',
          priority
        }
      });
      setSwitch(true);
      setPriority(emailObject.priority === 1);
    }

    if (emailObject && emailId) {
      const {
        cc, bcc, sendTo, sendFrom, subject, body, attachments, template, emailType, priority
      } = emailObject;
      setstate(prevState => {
        return {
          ...prevState,
          template,
          sendFrom,
          sendTo,
          subject,
          emailType,
          body,
          attachments,
          bcc,
          cc,
          priority
        }
      });
      setPriority(emailObject.priority === 1);
    }
  }, [emailObject, emailId, state.template]);

  useEffect(() => {
    if (!_.isEmpty(templates)) {
      setTemplateOpt(
        _.map(templates, (template) => ({
          label: template.description,
          value: template.tmpId,
          description: template.description
        }))
      );
    }
  }, [templates]);

  useEffect(() => {
    setstate(prevState =>{
      return {
        ...prevState,
        priority: priority ? 1 : 3
      }
    });
  }, [priority]);

  const getMode = useCallback(() => view || !state.template, [view, state.template]);

  const getFromEmail = useCallback(() => {
    const viewMode = getMode();
    if (emailObject && state.template) {
      return emailObject.sendFrom;
    }
    return viewMode ? emailObject?.sendFrom : noReplyEmail;
  }, [emailObject, state.template, getMode]);

  useEffect(() => {
    if (!switchAc && _.isEmpty(emailId)) {
      setstate(prevState => {
        return {
          ...prevState,
          sendFrom: session.emailAddress || sendMailId
        }
      });
    } else {
      setstate(prevState => {
        return {
          ...prevState,
          sendFrom: getFromEmail()
        }
      });
    }
  }, [switchAc, getFromEmail, sendMailId, session.emailAddress, emailId]);

  const disableSend = () => view || !state.sendTo;

  const handleChange = (name, e) => {
    if (name === 'template') {
      clearEmailObjectAc();
      const postBody = {
        keyValue,
        objType: orgType,
        objDbId: dbId
      };
      setSwitch(false);
      if (e.value && e.value !== 'FREE_FORM') {
        bindLogger(fetchEmailObject, context)(postBody, e.value);
        setstate(prevState => {
          return {
            ...prevState,
            [name]: e
          }
        });
      } else {
        bindLogger(fetchProcessKey, context)().subscribe((resp) => {
          setstate(prevState => {
            return {
              ...prevState,
              [name]: e,
              sendFrom: session.emailAddress,
              processKey: resp,
              sendTo: '',
              subject: '',
              emailType: '',
              body: '',
              attachments: [],
              bcc: '',
              cc: ''
            };
          });
        });
      }
    }
  };
  const changeHandler = (e) => {
    setstate(prevState => {
      return {
        ...prevState,
        [e.target.name]: e.target.value
      }
    });
    if (!session.emailAddress && e.target.name === 'sendFrom') {
      setSendMailId(e.target.value);
    }
  };
  const switchEmail = () => {
    setSwitch(!switchAc);
  };

  const doUpload = (file) => {
    const formData = new FormData();
    formData.append('file', file);
    const headers = {
      Authorization: `Bearer ${getToken()}`,
      filename: file.name
    };
    const url = `${process.env.REACT_APP_ORIGIN}esys-data-service/v1/email/upload/${state.processKey || emailObject.processKey
      }/attachment`;
    return fetch(url, {
      method: 'POST',
      body: formData,
      headers
    });
  };

  const buildNotification = (successFileList, errorFileList) => (
    <ul style={{ listStyleType: 'none' }}>
      {successFileList != null && successFileList.length > 0 && successFileList.map((item) => (
        <li key={`${item}`} style={{ color: '#21C15A', width: '45em' }}>
          <strong>{item}</strong>
          {' '}
          is uploaded successfully.
        </li>
      ))}
      {errorFileList != null && errorFileList.length > 0 && errorFileList.map((item) => (
        <li
          key={item}
          style={{
            color: '#AB0731',
            width: '45em'
          }}
        >
          <strong>{item}</strong>
          {' '}
          is not uploaded successfully.
        </li>
      ))}
    </ul>
  );

  const checkResults = (results, files) => {
    const listVals = {
      successFileList: [],
      errorFileList: []
    };
    const attachmentsList = state.attachments ? [...state.attachments] : [];
    results.forEach((eachPromise, i) => {
      if (eachPromise.status === 'fulfilled') {
        listVals.successFileList.push(files[i].name);
        attachmentsList.push({
          attachmentFileName: files[i].name,
          ancillaryId: 0,
          path: URL.createObjectURL(files[i])
        });

      } else {
        listVals.errorFileList.push(files[i].name);
      }
    });
    setstate(prevState => {
      return {
        ...prevState,
        attachments: [...attachmentsList]
      }
    });
    return listVals;
  };

  const showSuccessorErrorInfo = (listVals) => {
    const { successFileList, errorFileList } = listVals;
    if (errorFileList.length === 0) {
      showSuccessNotification(buildNotification(successFileList, null));
    } else if (errorFileList.length > 0 && successFileList.length === 0) {
      showErrorNotification(buildNotification(null, errorFileList));
    } else {
      showWarningNotification(buildNotification(successFileList, errorFileList));
    }
  };

  const onChangeFile = (files) => {
    if (files != null) {
      if (files.length <= 5) {
        setIsUploading(true);
        const allPromises = files.map((eachFile) => doUpload(eachFile));
        Promise.allSettled(allPromises).then((results) => {
          const listVals = checkResults(results, files);
          showSuccessorErrorInfo(listVals);
        })
          .catch((e) => {
            showErrorNotification('Documents upload was not successful');
            throw new Error(getErrorMessage(e, 'message'));
          }).finally(() => {
            setIsUploading(false);
          });
      } else {
        showErrorNotification('Maximum 5 files can be uploaded at a time.');
      }
    }
  };

  const deleteFile = (fileArr, index, file, e) => {
    const fileName = file.attachmentFileName ? file.attachmentFileName : file.name;
    fileArr.splice(index, 1);
    setstate(prevState => {
      return {
        ...prevState,
        attachments: fileArr
      }
    });
    showSuccessNotification(`${fileName} file removed successfully.`);
    e.stopPropagation();
    e.preventDefault();
  };

  const onDelete = (e) => {
    const { index } = e.currentTarget.dataset;
    const fileArr = state.attachments;
    const file = state.attachments[index];
    const processKey = state.processKey || emailObject.processKey;
    bindLogger(deleteAttachmentAc, context)(processKey, file.attachmentFileName).subscribe(() => {
      deleteFile(fileArr, index, file, e);
    });
  };

  const onDrop = (acceptedFiles, rejectedFiles) => {
    if (rejectedFiles.length > 0) {
      OpenErrorNotification({
        message: 'File type is not allowed.',
        autoHide: true,
        displayTimeInSec: 15
      });
    } else if (acceptedFiles.length > 0) {
      onChangeFile(acceptedFiles);
    } else if (acceptedFiles.length === 0) {
      OpenWarningNotification({
        message: 'Please select files for uploading.',
        autoHide: true,
        displayTimeInSec: 15
      });
    }
  };

  const {
    getRootProps, getInputProps, isDragActive, fileRejections
  } = useDropzone({
    onDrop,
    multiple: true,
    disabled: getMode(),
    accept: allowedFileTypes
  });

  const emailFormCheck = () => {
    const { subject, body } = state;
    let errorData = errors;
    let check = true;
    if (showReason && _.isEmpty(reason)) {
      errorData = {
        ...errorData,
        reason: 'Follow up reason is mandatory.'
      };
      check = false;
    }
    if (_.isEmpty(subject)) {
      errorData = {
        ...errorData,
        subject: 'Email Subject is mandatory.'
      };
      check = false;
    }
    if (_.isEmpty(body)) {
      errorData = {
        ...errorData,
        body: 'Email Body is mandatory'
      };
      check = false;
    }
    setErrors({
      ...errorData
    });
    return check;
  };

  const sendEmail = () => {
    const {
      sendTo, sendFrom, subject, body, attachments, bcc, cc, template
    } = state;
    if (emailFormCheck()) {
      const attachList = _.map(attachments, attachment => {
        const dataItem = attachment;
        if (dataItem.path) {
          delete dataItem.path;
        }
        return dataItem;
      });
      const postBody = {
        keyValue,
        objType: orgType,
        objDbId: dbId,
        action: 'NEW',
        origEmailId: null,
        esysTemplateDataDto: {
          processKey: state.processKey || (emailObject && emailObject.processKey),
          owner: emailObject && emailObject.owner,
          priority: state.priority,
          sendTo,
          sendFrom,
          subject,
          body,
          attachments: attachList || [],
          bcc,
          cc
        }
      };
      bindLogger(sendEmailObjAc, context)(postBody, template.value).subscribe((resp) => {
        showSuccessNotification('Email sent successfully.');
        resetState();
        if (orgType === 'CAP_SCREEN') {
          cancelCommunicationHanlder(JSON.parse(resp.response), reason, keyValue);
        } else {
          cancelCommunicationHanlder(JSON.parse(resp.response), saveRec, reason);
        }
      });
    }
  };

  const cancelEmail = () => {
    resetState();
    cancelCommunicationHanlder();
  };

  const loadFiles = (files) => files.map((file, i) => {
    const name = file.name ? file.name : file.attachmentFileName;
    const id = file.id ? file.id : file.ancillaryId;
    const emailContext = file.id ? 'EMAIL' : 'EMAIL_NEW';
    return (
      <div key={id} className="file-container p-1 m-1">
        {id !== 0 && (
          <DocumentHelper
            docId={id}
            type="text"
            docContext={emailContext}
            docFileName={name}
            getToken={getToken}
            appName={process.env.REACT_APP_NAME}
          />
        )}
        {file.path && (
          <a rel="noopener noreferrer" target="_blank" href={file.path}>
            {name}
          </a>
        )}
        <button
          disabled={view}
          data-index={i}
          onClick={onDelete}
          type="button"
          className="fn-btn font-lg ml-2"
          title="Delete"
        >
          <FasTimes />
        </button>
      </div>
    );
  });

  const resetPriority = () => {
    setPriority(!priority);
  };

  const checkIcon = () => (showCopyPaste ? faCaretDown : faCaretUp);

  const checkMargin = () => (showCopyPaste ? '28em' : '4.5em');

  const checkDisplay = () => (showCopyPaste ? 'none' : 'inline-block');

  const checkCopyPaste = () => (
    <div className={`${showCopyPaste ? 'd-inline-flex' : 'd-none'} bg-cool-grey shadow-sm rounded p-3`}>
      <CopyPaste hideView={canShowCopyPaste} CopyPasteFields={CopyPasteFields} />
    </div>
  );

  const canViewCopPaste = () => CopyPasteFields && (
    <div style={{ position: 'absolute', right: '0', marginRight: checkMargin() }}>
      <div style={{ position: 'fixed', display: 'inline-flex' }}>
        <div>
          <button
            onClick={() => {
              canShowCopyPaste(!showCopyPaste);
            }}
            style={{
              transform: 'rotate(270deg)',
              borderRadius: '8px 8px 0px 0px',
              display: checkDisplay()
            }}
            data-id={`${ATC.PACKETID}COPY_PASTE${ATC.BUTTON}`}
            type="button"
            className="btn turquoise"
          >
            <div>
              <FontAwesomeIcon icon={checkIcon()} />
            </div>
            <div>Copy/Paste</div>
          </button>
        </div>
        {checkCopyPaste()}
      </div>
    </div>
  );

  const placeholder = isDragActive ? 'Drop the file here ...' : 'Drag and drop a file here, or click to select file';
  const getFromMailDisable = () => session.emailAddress || state.sendFrom === noReplyEmail || getMode();
  const getOrgtype = () => (orgType === 'CAP_SCREEN' ? 'CAP' : 'PACKET');

  const fileRejectionItems = fileRejections.map(({ file }) => (
    <div key={file.path}>
      <p className="pl-5">
        {`${file.path} - ${file.size} bytes`}
      </p>
      <p className="pl-5">
        {`allowed file types are : ${Object.values(allowedFileTypes).join(', ')}`}
      </p>
    </div>
  ));

  const showActions = () => (
    <li style={{ display: 'flex' }} className="justify-content-center">
    <button
      dataId={`${ATC.APP}COMMUNICATION_SEND_EMAIL${ATC.BUTTON}`}
      disabled={disableSend()}
      type="button"
      className="btn turquoise mx-1"
      onClick={sendEmail}
    >
      Send
    </button>
    <button
      dataId={`${ATC.APP}COMMUNICATION_CANCEL_EMAIL${ATC.BUTTON}`}
      type="button"
      className="btn close mx-1"
      onClick={cancelEmail}
    >
      Cancel
    </button>
  </li>
  );

  return (
    <div className="row">
      <div className="col-8">
        {!emailId && (
          <FormRow
            dataId={`${ATC.APP}${tagName}_TEMPLATE_FIELD${ATC.SELECT}`}
            value={state.template}
            label="Template"
            type="select"
            labelAlign="start"
            name="template"
            colSize="col-10"
            colLabel="col-2"
            error={errors.template}
            onChange={(e) => {
              handleChange('template', e);
            }}
            options={templateOpt}
            required
            readOnly={view}
          />
        )}
        {emailId && (
          <>
            <FormRow
              dataId={`${ATC.APP}${tagName}_SEND_DATE${ATC.TEXT}`}
              value={sendDate}
              colSize="col-10"
              colLabel="col-2"
              label="Send Date"
              name="sendDate"
              readOnly={view}
            />
            <FormRow
              dataId={`${ATC.APP}${tagName}_OBJ_TYPE${ATC.TEXT}`}
              value={getOrgtype()}
              label="Object Type"
              colSize="col-10"
              colLabel="col-2"
              labelAlign="start"
              name="objectType"
              readOnly={view}
            />
            <FormRow
              dataId={`${ATC.APP}${tagName}_OBJ_ID${ATC.TEXT}`}
              value={dbId}
              label="Object ID"
              colSize="col-10"
              colLabel="col-2"
              labelAlign="start"
              name="objectId"
              readOnly={view}
            />
          </>
        )}
        <FormRow
          dataId={`${ATC.APP}${tagName}FROM_FIELD${ATC.INPUT}`}
          value={state.sendFrom}
          label="From"
          name="sendFrom"
          colSize="col-10"
          colLabel="col-2"
          labelAlign="start"
          onChange={changeHandler}
          infoButton={
            !getMode() && (
              <button
                data-id={`${ATC.APP}${tagName}SWITCH${ATC.BUTTON}`}
                type="button"
                disabled={getMode()}
                className="btn ml-2 turquoise"
                onClick={switchEmail}
                title="Switch To and From fields"
              >
                Switch
              </button>
            )
          }
          readOnly={getFromMailDisable()}
        />
        <FormRow
          dataId={`${ATC.APP}${tagName}TO_FIELD${ATC.INPUT}`}
          value={state.sendTo}
          label="To"
          colSize="col-10"
          colLabel="col-2"
          labelAlign="start"
          required
          name="sendTo"
          onChange={changeHandler}
          readOnly={getMode()}
        />
        <FormRow
          dataId={`${ATC.APP}${tagName}CC_FIELD${ATC.INPUT}`}
          value={state.cc}
          label="CC"
          colSize="col-10"
          colLabel="col-2"
          labelAlign="start"
          name="cc"
          onChange={changeHandler}
          readOnly={getMode()}
        />
        <FormRow
          dataId={`${ATC.APP}${tagName}BCC_FIELD${ATC.INPUT}`}
          value={state.bcc}
          label="BCC"
          colSize="col-10"
          colLabel="col-2"
          labelAlign="start"
          name="bcc"
          onChange={changeHandler}
          readOnly={getMode()}
        />
        <FormRow
          dataId={`${ATC.APP}${tagName}SUBJECT${ATC.INPUT}`}
          value={state.subject}
          name="subject"
          colSize="col-10"
          colLabel="col-2"
          labelAlign="start"
          label="Email Subject"
          required
          onChange={changeHandler}
          readOnly={getMode()}
          error={errors.subject}
        />
        <li>
          <Label
            colLabel="col-2"
            labelAlign="start"
            label="Attachments"
            icon={<FontAwesomeIcon icon={faPaperclip} className="mr-1" />}
          />
          <div className="form-layout-input col-10">
            {isUploading ? (
              <button data-id={`${ATC.PACKETID}EMAIL_REFRESH_UPLOAD${ATC.BUTTON}`} type="button" className="btn mr-1">
                <FontAwesomeIcon icon={faSpinner} spin className="mr-1" />
                <span className="mr-5">Upload file inprogress</span>
              </button>
            ) : (
              <>
                <div className={`attachment-dropzone mt-2 ${getMode() && 'attachment-dropzone-disabled'}`}>
                  <div {...getRootProps()}>
                    <div>
                      <input webkitdirectory {...getInputProps()} />
                      <p style={{ height: '3.5rem' }}>{state.template && placeholder}</p>
                    </div>
                  </div>
                </div>
                {fileRejectionItems && fileRejectionItems.length > 0 ? (
                  <div className="form-layout-message-error">
                    {fileRejectionItems}
                  </div>
                ) : null}
              </>
            )}
          </div>
        </li>
        {state.attachments && state.attachments.length > 0 && (
          <li style={{ display: 'flex' }} className="justify-content-center">
            {loadFiles(state.attachments)}
          </li>
        )}
        <li>
          <Label colLabel="col-2" labelAlign="start" label="Email Body" />
          <div className="form-layout-input col-10 d-flex justify-content-end">
            <button
              data-id={`${ATC.APP}${tagName}EXCLAMATION_ICON${ATC.BUTTON}`}
              onClick={resetPriority}
              type="button"
              className={`fn-btn justify-content-end font-lg mx-1 ${priority && 'color-red'}`}
              disabled={getMode()}
              title={`Toggle Priority | ${priority ? 'High' : 'Regular'}`}
            >
              <FontAwesomeIcon icon={faExclamationTriangle} />
              {priority ? 'High' : 'Regular'}
            </button>
          </div>
        </li>
        <li className="ml-4">
          <div className="form-layout-input col-12 ml-4">
            <textarea
              value={state.body}
              name="body"
              disabled={getMode()}
              required
              onChange={changeHandler}
              rows="15"
              data-id={`${ATC.APP}${tagName}BODY${ATC.TEXTAREA}`}
            />
            {errors.body != null ? (
              <div style={{ marginLeft: '1em', marginRight: '-1em' }} className="form-layout-message-error">
                {errors.body}
              </div>
            ) : null}
          </div>
        </li>
        {!view && showActions()}
      </div>
      <div className="col-4" />
      {canViewCopPaste()}
    </div>
  );
}

const mapStateToProps = (state) => ({
  templates: state.email.templates,
  emailObject: state.email.emailObject
});

const withConnectState = connect(mapStateToProps, (dispatch) => bindActionCreators(
  {
    fetchTemplates: getTemplates,
    fetchEmailObject: getEmailObject,
    sendEmailObjAc: sendEmailObj,
    deleteAttachmentAc: deleteAttachment,
    fetchProcessKey: getProcessKey,
    clearEmailObjectAc: clearEmailObject
  },
  dispatch
));

export default withConnectState(EmailGenerator);